export const translationLivechat_en_part1 = {
  livechatDefaultSupportAgent: "Support Agent",
  livechatPageTitle: "Livechat",
  livechatWorkspaceEyebrow: "Livechat workspace",
  livechatWorkspaceTitle: "Handle the full livechat lifecycle from the dashboard",
  livechatWorkspaceSubtitle:
    "Work the waiting queue, join conversations, respond with attachments, manage your agent profile, and close sessions without leaving the dashboard.",
  livechatStatusWaiting: "Waiting",
  livechatNotificationOsTitle: "Live chat",
  livechatNotificationOsBody: "New live chat activity is waiting for you.",
  livechatConnectionLost:
    "Live updates are disconnected. New chats and notifications may not appear until the connection is restored.",
  livechatConnectionLostRetry: "Retry",
  livechatOsNotificationsOff:
    "Browser notifications are off — you won't be alerted about new chats while this tab is not focused.",
  livechatOsNotificationsEnable: "Enable notifications",
  livechatOsNotificationsBlocked:
    "Notifications are blocked by your browser. Allow notifications for this site in your browser settings to get alerted about new chats.",
  livechatWaitingNotificationAriaSingular: "Waiting, 1 waiting session",
  livechatWaitingNotificationAriaPlural: "Waiting, {count} waiting sessions",
  livechatOurTurnNotificationAriaSingular: "{label}, 1 active conversation needs your reply",
  livechatOurTurnNotificationAriaPlural: "{label}, {count} active conversations need your reply",
  livechatStatusActive: "Active",
  livechatStatusClosed: "Closed",
  livechatTurnFilterAll: "All",
  livechatTurnFilterOurTurn: "Our turn",
  livechatTurnFilterTheirTurn: "Their turn",
  livechatEnvLive: "Live",
  livechatEnvTest: "Test",
  livechatBadgeLiveMode: "LIVE MODE",
  livechatBannerLiveTitle: "Live customer workspace",
  livechatBannerLiveDescription:
    "Sessions, webhooks, agent profile, and settings on this page affect live traffic.",
  livechatBadgeTestMode: "TEST MODE",
  livechatBannerTestTitle: "Sandbox livechat workspace",
  livechatBannerTestDescription:
    "Sessions, webhooks, agent profile, and settings on this page are isolated to test mode.",
  livechatIndicatorTooltipOffline: "Livechat is offline for visitors. {reason}",
  livechatIndicatorAriaOffline: "Livechat offline for visitors. {reason}",
  livechatIndicatorLoading: "Loading livechat availability…",
  livechatIndicatorNoChatbot: "Select a chatbot to see availability.",
  livechatFilterChatbotLabel: "Chatbot",
  livechatFilterAllChatbots: "All chatbots",
  livechatFilterMultipleChatbots: "{count} chatbots",
  livechatCannedResponsesTitle: "Canned responses",
  livechatCannedResponsesBack: "Back to livechat",
  livechatCannedResponsesDescription:
    "Create canned responses that agents can insert into livechat with a button or slash command.",
  livechatCannedResponsesAdd: "Add canned response",
  livechatCannedResponsesCreateFolder: "Create folder",
  livechatCannedResponsesChatbotLabel: "Chatbot",
  livechatCannedResponsesFolderNameLabel: "Folder name",
  livechatCannedResponsesFolderNamePlaceholder: "E.g. Claims",
  livechatCannedResponsesFolderSave: "Save folder",
  livechatCannedResponsesFolderNameRequired: "Folder name is required.",
  livechatCannedResponsesFolderSaveFailed: "Failed to save folder.",
  livechatCannedResponsesFolderDeleteFailed: "Failed to delete folder.",
  livechatCannedResponsesFolderLabel: "Folder",
  livechatCannedResponsesFolderScopeHint:
    "Folders are per chatbot. Select only {chatbotId} to place this response in a folder.",
  livechatCannedResponsesNoFolder: "No folder",
  livechatCannedResponsesFolderEmpty: "Drag canned responses here to store them in this folder.",
  livechatCannedResponsesFolderExpand: "Expand",
  livechatCannedResponsesFolderCollapse: "Collapse",
  livechatCannedResponsesDragHint: "Drag to move to a folder",
  livechatCannedResponsesMoveFailed: "Failed to move canned response.",
  livechatCannedResponsesCommandLabel: "Command",
  livechatCannedResponsesTitleLabel: "Title",
  livechatCannedResponsesBodyLabel: "Response text",
  livechatCannedResponsesScopeLabel: "Available on",
  livechatCannedResponsesScopeHelp:
    "Choose which chatbots this canned response should be available for.",
  livechatCannedResponsesScopeAll: "All chatbots",
  livechatCannedResponsesEditScopeNotice: "Changes apply to all {count} selected chatbots.",
  livechatCannedResponsesTitlePlaceholder: "E.g. Complaint follow-up",
  livechatCannedResponsesBodyPlaceholder: "Write the reply that should be inserted into chat...",
  livechatCannedResponsesSave: "Save canned response",
  livechatCannedResponsesSaving: "Saving...",
  livechatCannedResponsesLoading: "Loading canned responses...",
  livechatCannedResponsesEmpty: "No canned responses have been created for this chatbot yet.",
  livechatCannedResponsesNoMatches: "No canned responses match your slash command.",
  livechatCannedResponsesLoadFailed: "Failed to load canned responses.",
  livechatCannedResponsesSaveFailed: "Failed to save canned response.",
  livechatCannedResponsesDeleteFailed: "Failed to delete canned response.",
  livechatCannedResponsesDeleteConfirmTitle: "Delete canned response?",
  livechatCannedResponsesDeleteConfirmDescription:
    "This deletes {command} from {chatbotCount} {chatbotLabel}: {chatbots}.",
  livechatCannedResponsesFormRequired: "Command, title, and response text are required.",
  livechatCannedResponsesInsert: "Insert",
  livechatCannedResponsesKeyboardHint: "↑↓ navigate · Enter insert · Esc close",
  livechatEdit: "Edit",
  livechatDelete: "Delete",
  livechatAgentProfileSet: "Set profile",
  livechatAgentProfile: "Agent profile",
  livechatSettingsAriaLabel: "Livechat settings",
  livechatSettingsTitleAttr: "Livechat settings",
  livechatBackToConversation: "Back to conversation",
  livechatVisitorSessions: "Visitor sessions",
  livechatNoTimestamp: "No timestamp",
  livechatAriaOpenSession: "Open {status} livechat session {sessionId}",
  livechatJustNow: "Just now",
  livechatUnknown: "Unknown",
  livechatSessionsEmptyFilters: "No livechat sessions match the current filters.",
  livechatLoadingMoreSessions: "Loading more sessions...",
  livechatEndOfList: "End of list",
  livechatTurnOurTurn: "Our turn",
  livechatTurnTheirTurn: "Their turn",
  livechatVisitorLabel: "Visitor",
  livechatCustomerTyping: "Customer typing",
  livechatAgentTyping: "Agent typing",
  livechatAssignedTo: "Assigned to",
  livechatUnassigned: "Unassigned",
  livechatEnvLiveLower: "live",
  livechatEnvTestLower: "test",
  livechatSessionStatusWaiting: "waiting",
  livechatSessionStatusActive: "active",
  livechatSessionStatusClosed: "closed",
  livechatActiveTurnFilterAria: "Active livechat turn filter",
  livechatSelectChatbotBeforeSettings: "Select a chatbot before changing livechat settings.",
  livechatFailedSaveProfile: "Failed to save the livechat profile.",
  livechatFailedJoinSession: "Failed to join the livechat session.",
  livechatFailedSendReply: "Failed to send the livechat reply.",
  livechatFailedTakeoverProviderControl: "Failed to take over the livechat session.",
};
